/*! StartNoStringValidationRegion Authentication Source */
export enum AuthenticationSource {
  Local,
  RemoteEdiProd,
  Nexus,
  MyAccountGateway,
}
/*! EndNoStringValidationRegion */
